import { combineReducers } from 'redux'
import { AppReducer, AppState } from './AppRedux'
import { createBrowserHistory } from 'history'
import { connectRouter } from 'connected-react-router'
import { StartupReducer, StartupState } from 'Reducers/StartupRedux'
import { LoginReducer, LoginState } from 'Reducers/LoginRedux'
import { PaymentReducer, PaymentState } from 'Reducers/PaymentPersistingRedux'
import { WellhubReducer, WellhubState } from 'Reducers/WellhubRedux'
import { UscReducer, UscState } from 'Reducers/UscRedux'
import { OnboardingReducer, OnboardingState } from './OnboardingRedux'

export interface IRootState {
  router: any
  App: AppState
  startup: StartupState
  onboarding: OnboardingState
  login: LoginState
  payment: PaymentState
  wellhub: WellhubState
  usc: UscState
}

export const history = createBrowserHistory()

export const rootReducer = combineReducers<IRootState>({
  router: connectRouter(history),
  App: AppReducer,
  onboarding: OnboardingReducer,
  startup: StartupReducer,
  login: LoginReducer,
  payment: PaymentReducer,
  wellhub: WellhubReducer,
  usc: UscReducer
})
